import { isEmpty } from 'lodash';
import React from 'react';
import TreeView from '@mui/lab/TreeView';
import { Button } from '@mui/material';
import UnfoldLessIcon from '@mui/icons-material/UnfoldLess';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import { extractProperty } from '@utils';

import { DescriptionsTree } from './models';
import { TypeTreeItem } from './components';

const ToggleIcon = (props: {
  allNodeIds: DescriptionsTree.NodeId[];
  expandedNodes: DescriptionsTree.NodeId[];
}) =>
  props.allNodeIds.length === props.expandedNodes.length ? (
    <UnfoldLessIcon sx={{ marginRight: '-10px' }} />
  ) : (
    <UnfoldMoreIcon sx={{ marginRight: '-10px' }} />
  );

export interface FeatureDomainDescriptionsTreeProps {
  descriptionsTree: DescriptionsTree;
}

export const FeatureDomainDescriptionsTreeHeader = (
  props: React.PropsWithChildren<Record<never, any>>
) => <>{props.children}</>;

export const DomainsDescriptionsTree: React.FC<
  FeatureDomainDescriptionsTreeProps
> = ({ descriptionsTree, children }) => {
  const [allNodeIds, setAllNodeIds] = React.useState(() =>
    getAllNodeIds(descriptionsTree)
  );
  const [expandedNodes, setExpandedNodes] = React.useState<
    DescriptionsTree.NodeId[]
  >(() => []);

  React.useEffect(() => {
    setAllNodeIds(getAllNodeIds(descriptionsTree));
  }, [descriptionsTree]);

  return (
    <div className="domains-descriptions-tree">
      <div className="domains-descriptions-tree-header">
        <Button
          className="toggle-all-nodes-btn"
          variant="outlined"
          startIcon={
            <ToggleIcon allNodeIds={allNodeIds} expandedNodes={expandedNodes} />
          }
          onClick={() =>
            setExpandedNodes(isEmpty(expandedNodes) ? allNodeIds : [])
          }
        />

        {React.Children.toArray(children)
          .filter(React.isValidElement)
          .filter(child => child?.type === FeatureDomainDescriptionsTreeHeader)}
      </div>
      <div>
        <TreeView
          defaultCollapseIcon={<ExpandMoreIcon />}
          defaultExpandIcon={<ChevronRightIcon />}
          disabledItemsFocusable={false}
          multiSelect={true}
          expanded={expandedNodes}
          onNodeToggle={(_, nodeIds) => setExpandedNodes(nodeIds)}
        >
          {descriptionsTree.types.map(type => (
            <TypeTreeItem key={type.nodeId} type={type} />
          ))}
        </TreeView>
      </div>
    </div>
  );
};

function getAllNodeIds(tree: DescriptionsTree): DescriptionsTree.NodeId[] {
  return tree.types
    .map(({ columns, nodeId }, typeIdx) => [
      nodeId,
      columns.map(extractProperty('nodeId')),
    ])
    .flat(2);
}
